import { normalizeExerciseName } from "./exerciseIdentity";
import { verifiedExerciseMedia } from "../data/verifiedExerciseMedia";

/**
 * Return a human-reviewed illustration for an exercise, or null.
 *
 * This resolver intentionally has NO fuzzy image matching, category fallback,
 * remote URL fallback, or legacy ID fallback. A missing picture is preferable
 * to showing the wrong movement.
 *
 * The unused arguments remain in the signature so existing callers do not
 * need a breaking API change while the verified library is built out.
 */
export function getExerciseMedia(exerciseId, muscleGroup = null, exerciseName = null, imageUrl = null) {
  void exerciseId;
  void muscleGroup;
  void imageUrl;

  const canonicalName = normalizeExerciseName(exerciseName || '');
  if (!canonicalName) return null;

  return verifiedExerciseMedia[canonicalName] || null;
}
